var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _ellipse2, _ellipse3, _ellipse4, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.382 37.522L68.1605 80.3005L10.2244 103.179C7.87907 104.182 5.13018 103.783 3.29551 101.949C1.45217 100.105 1.05806 97.339 2.07889 94.9865L2.07816 94.9857L25.382 37.522Z",
    fill: "#8654FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.5641,
    cy: 58.1195,
    rx: 30.4828,
    ry: 8.96552,
    transform: "rotate(45 47.5641 58.1195)",
    fill: "#5216B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7469 63.7485L19.5805 51.8296C19.9146 52.8704 20.486 54.2022 21.3604 55.8053C23.8343 60.3408 28.1941 66.0725 33.9124 71.7908C39.6306 77.5091 45.3623 81.8689 49.8978 84.3428C51.3763 85.1492 52.624 85.6979 53.6256 86.0404L41.6593 90.7659C36.9963 87.7426 31.9197 83.5867 27.0181 78.6851C22.0128 73.6798 17.785 68.492 14.7469 63.7485ZM7.00679 82.8344L10.2785 74.7668C12.7624 78.2684 15.9892 82.0976 19.799 85.9074C23.4692 89.5776 27.1573 92.7067 30.5532 95.1517L22.4429 98.3545C19.8165 96.2286 17.1422 93.8218 14.5134 91.193C11.7413 88.4209 9.21603 85.5982 7.00679 82.8344Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9252 69.7433C58.5467 60.8384 74.8883 59.5677 85.7028 70.4411C86.4817 71.2243 86.4783 72.4906 85.6951 73.2696C84.912 74.0485 83.6456 74.045 82.8667 73.2619C74.0727 64.42 60.3519 64.9115 50.0956 72.3366C49.0511 71.5228 47.992 70.6571 46.9252 69.7433Z",
    fill: "#FF215C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9147 101.531C3.03383 101.675 3.16067 101.814 3.29523 101.949C5.1288 103.782 7.87551 104.182 10.2199 103.181L69.4975 79.7701C69.4975 79.7701 64.6035 81.065 59.9823 78.6275C55.521 76.2743 51.6042 73.4479 51.3384 73.2551L7.29667 101.251C5.88635 101.853 4.3302 101.949 2.9147 101.531Z",
    fill: "#5719B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3364 55.575C35.8873 52.2082 38.2351 47.7286 39.1838 42.6387C40.4889 35.6373 39.1713 27.3818 31.8675 19.0841C31.3202 18.4623 31.3806 17.5144 32.0024 16.9671C32.6243 16.4197 33.5721 16.4801 34.1194 17.102C42.0432 26.1041 43.604 35.2971 42.133 43.1885C41.0315 49.0981 38.2435 54.2211 35.2737 57.9721C34.5992 57.1667 33.9529 56.3666 33.3364 55.575Z",
    fill: "#00B3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1705 53.1479C64.7218 51.4655 68.6572 48.1739 73.2708 49.5667C77.368 50.8036 77.6192 53.9931 82.372 54.3305C87.1248 54.668 88.2152 50.9428 93.3509 51.1032C97.471 51.2319 100.186 55.5602 100.186 55.5602",
    stroke: "#FF8A00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1866 41.1992C51.3277 38.7161 48.4925 34.5814 50.8561 30.5327C52.9347 26.972 57.6009 28.3466 58.6577 23.7132C59.7145 19.0797 54.8624 16.0631 57.3986 10.5499C58.8971 7.29229 65.0728 6.59585 65.0728 6.59585",
    stroke: "#085CFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 36,
    r: 4.5,
    fill: "#FFC804"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 29.5,
    rx: 6,
    ry: 6,
    transform: "rotate(90 11 29.5)",
    fill: "#21C35D"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95,
    cy: 33.5,
    rx: 3,
    ry: 3,
    transform: "rotate(90 95 33.5)",
    fill: "#FF215C"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.5,
    cy: 25,
    rx: 3.5,
    ry: 3.5,
    transform: "rotate(90 81.5 25)",
    fill: "#21C35D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 94.5,
    r: 5,
    transform: "rotate(90 79 94.5)",
    fill: "#9A6CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a511854d6c6fdada4d1a75d0df38841a.svg";
export { ForwardRef as ReactComponent };